<template>
  <div class="container">
    <!-- 头部banner -->
    <top-banner></top-banner>
    <!-- banner -->
    <img src="@/common/images/aboutUs/aboutUs_bg.png" class="banner_aboutUs" />
    <!-- content -->
    <div class="content_aboutUs">
      <img src="@/common/images/aboutUs/content_bg.png" class="content_bg" />
      <div class="content_ab">
        <div class="ab_title">联系我们</div>
        <div class="ab_linec">
          <div class="linec_l">服务热线：</div>
          <div class="linec_r">
            <div class="linec_r1">0531-62323890(市场)</div>
            <div class="linec_r1">0531-62323896(服务)</div>
          </div>
        </div>
        <div class="ab_address">地址：中国（山东）自由贸易试验区济南片区舜华路2000号舜泰广场6号楼2103-2</div>
        <div class="ab_map">

          <baidu-map class="bm-view" ak="F7bd79798568910923295df9a70ee3e2" :center="center" :zoom="zoom"
            @ready="handler" :scroll-wheel-zoom="true">
            <bm-marker :position="{lng: center.lng, lat: center.lat}" :icon="markerIcon" animation="BMAP_ANIMATION_DROP">
            </bm-marker>
          </baidu-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import topBanner from '@/components/topBanner.vue'
  import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
  import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
  export default {
    components: {
      topBanner,
      BaiduMap,
      BmMarker,
    },
    data() {
      return {
        curPage:'aboutUs',
        center: {
          lng: 0,
          lat: 0
        },
        zoom: 16,
        markerIcon:{
          url: require('@/common/images/aboutUs/map_dot.png'),
          size: {width: 42, height: 47}
        },
      }
    },
    methods: {
      handler({
        BMap,
        map
      }) { //地图初始
        // console.log(BMap, map);
        // 117.150656,36.669068
        // 117.151246,36.670096
        this.center.lng = 117.151305;
        this.center.lat = 36.670183;
        this.zoom = 16;
        let _this = this;
        // var geolocation = new BMap.Geolocation();
        // geolocation.getCurrentPosition(function(r) {
        //   _this.center = {
        //     lng: r.longitude,
        //     lat: r.latitude
        //   }; // 设置center属性值
        // })
      },
    },
  }
</script>

<style>
  .container {
    position: relative;
  }

  .banner_aboutUs {
    width: 1920px;
    height: 1080px;
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .content_aboutUs {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1920px;
    height: 940px;
    padding-top: 140px;
  }

  .content_bg {
    width: 1475px;
    height: 789px;
  }

  .content_ab {
    width: 1475px;
    height: 789px;
    position: absolute;
    left: 222px;
    top: 215px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @keyframes topIn {
    from {
      transform: translateY(-30px);
      opacity: 0;
    }

    to {
      transform: translateY(0px);
      opacity: 1;
    }
  }

  .ab_title {
    font-size: 60px;
    line-height: 180px;
    animation: topIn 1s ease;
  }

  .ab_linec {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 42px;
    width: 900px;
    letter-spacing: 6px;
  }

  .linec_l {
    width: 330px;
    line-height: 60px;
    animation: topIn 1.2s linear;
  }

  .linec_r {
    display: flex;
    flex-direction: column;
    width: 570px;
    letter-spacing: 7px;
    animation: topIn 1.2s linear;
  }

  .linec_r1 {
    line-height: 60px;
  }

  .ab_address {
    width: 100%;
    font-size: 26px;
    line-height: 120px;
    letter-spacing: 1px;
    animation: topIn 1.2s ease-out;
    text-align: center;
  }

  .ab_map {
    width: 880px;
    height: 300px;
    background-color: #fff;
  }

/*地图*/

.bm-view {
  position:relative;
  z-index: 1;
  width: 880px;
  height: 300px;
  background-color: #fff;

}
.anchorBL{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs.vue